import BaseAPI from '../base/baseApi';

export default class BusApi extends BaseAPI {
  apiName = 'BusinessSystem';
}
